import { useEffect, useState } from "react";
import { api } from "@/lib/pfc";
import { Calendar, MapPin } from "lucide-react";

export default function Events() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/events").then((r) => setItems(r.data)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-14" data-testid="events-page">
      <div className="mb-12">
        <div className="label text-pfc-gold mb-3">Events Calendar</div>
        <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl text-white uppercase leading-[0.9]">
          Upcoming <span className="gold-text">Premieres</span> & Mixers
        </h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="events-grid">
        {items.map((e) => {
          const d = new Date(e.date);
          return (
            <div key={e.event_id} className="pfc-card flex flex-col md:flex-row overflow-hidden" data-testid={`event-${e.event_id}`}>
              <img src={e.cover_image} alt={e.title} className="md:w-56 md:h-auto h-48 object-cover" />
              <div className="p-6 flex-1">
                <span className="label bg-pfc-gold text-ink-900 px-2 py-1">{e.category}</span>
                <h3 className="font-display text-2xl text-white uppercase mt-3 leading-tight">{e.title}</h3>
                <p className="text-white/60 text-sm mt-3 font-body line-clamp-2">{e.description}</p>
                <div className="mt-4 space-y-1.5 text-white/70 text-sm font-body">
                  <p className="flex items-center gap-2"><Calendar size={14} className="text-pfc-gold" />{d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric", year: "numeric" })}</p>
                  <p className="flex items-center gap-2"><MapPin size={14} className="text-pfc-gold" />{e.location}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
